import FaqCoordinators from './FaqCoordinators';
import ForumReports from './ForumReports';
import _certificate_management from './_certificate_management';
import _classroom_management from './_classroom_management';
import _communication from './_communication';
import _configurations from './_configurations';
import _corporate_reports from './_corporate_reports';
import _courses from './_courses';
import _ecommerce from './_ecommerce';
import _evaluations from './_evaluations';
import _financial from './_financial';
import _payment_deals from './_payment_deals';
import _professor_area from './_professor_area';
import _sales from './_sales';
import _secretary from './_secretary';
import _students_teachers from './_students_teachers';
import _teaching_resources from './_teaching_resources';
import academic_record_equivalencies from './AcademicRecordEquivalencies';
import academic_records from './academic_records/AcademicRecords';
import action_logs from './ActionLogs';
import agents from './Agents';
import assessment_questions from './assessments/AssessmentQuestions';
import assessment_user_attempts from './assessments/UserAttempts';
import assessments from './assessments/Assessments';
import assessments_attepts from './assessments/AssessmentsAttempts';
import assignment_attempts from './assignments/AssignmentAttempts';
import assignments from './assignments/Assignments';
import bonuses from './Bonuses';
import bulk_bonuses from './BulkBonuses';
import bulk_certificates from './BulkCertificates';
import bulk_user_suspends from './BulkUserSuspends';
import bulk_users from './BulkUsers';
import certificates_free_courses from './CertificateFreeCourses';
import certificates_regulated_courses from './certificates_management/CertificatesRegulatedCourses';
import certifying_institutions from './Certifiers';
import classroom_enrollments from './ClassroomEnrollments';
import classroom_evaluations from './ClassroomEvaluations';
import classroom_professors from './ClassroomProfessors';
import classrooms from './Classrooms';
import comments from './Comments';
import companies from './Companies';
import complementary_activities from './users/ComplementaryActivities';
import contents from './libraries/Contents';
import contracts from './Contracts';
import coupons from './Coupons';
import course_academic_results from './corporate_reports/CourseAcademicResults';
import course_completion from './corporate_reports/CourseCompletion';
import course_enrollment from './users/CourseEnrollment';
import course_portfolios from './corporate_reports/CoursePortfolios';
import courses from './Courses';
import courses_academic_calendars from './CoursesAcademicCalendars';
import discipline_academic_results from './corporate_reports/DisciplineAcademicResults';
import discussion_threads from './DiscussionThreads';
import document_template_courses from './DocumentTemplateCourses';
import document_templates from './DocumentTemplates';
import documentation_association from './DocumentationAssociation';
import documentations from './Documentations';
import ecommerce_divisions from './EcommerceDivisions';
import ecommerce_profit_centers from './EcommerceProfitCenters';
import ecommerce_tags from './EcommerceTags';
import enrolled_students from './corporate_reports/EnrolledStudents';
import equivalencies from './Equivalencies';
import external_items from './ExternalItems';
import fees from './Fees';
import fiscal_templates from './FiscalTemplates';
import forum from './Forum';
import franchise_management from './FranchiseManagement';
import graduate_courses from './GraduateCourses';
import graduate_courses_academic_calendars from './GraduateCoursesAcademicCalendars';
import graduate_courses_enrollment from './users/GraduateCoursesEnrollment';
import graduate_disciplines from './GraduateDisciplines';
import graduate_disciplines_modules from './GraduateDisciplinesModules';
import graduate_enrollment from './users/GraduateEnrollment';
import graduate_modules from './GraduateModules';
import hermes_gateways from './HermesGateways';
import home from './Home';
import instructors from './Instructors';
import interactive_classes from './InteractiveClasses';
import libraries from './Libraries';
import library_html_containers from './LibraryHtmlContainers';
import library_tag_groups from './LibraryTagGroups';
import library_tags from './LibraryTags';
import log_deleted_users from './LogDeletedUsers';
import manualOrders from './ManualOrder';
import noticeBoards from './NoticeBoards';
import offer_campaign_assets from './OfferCampaignAssets';
import offer_campaigns from './OfferCampaigns';
import offer_gateway_range_tables from './OfferGatewayRangeTables';
import offer_gateway_rules from './OfferGatewayRules';
import order_not_refunds from './OrderNotRefunds';
import order_payment_plan from './OrderPaymentPlan';
import order_payment_refunds from './OrderPaymentRefunds';
import order_refunds from './OrderRefunds';
import orders from './Orders';
import payment_method_rules from './PaymentMethodRules';
import payment_plan_deals_discounts from './discount_campaings/PaymentPlanDealsDiscounts';
import payment_plans from './PaymentPlans';
import personifications from './Personifications';
import possessions from './Possession';
import product_bundles from './ProductBundles';
import product_categories from './ProductCategories';
import product_sets from './ProductSets';
import products from './Products';
import prof_area_assessments from './professor_area/ClassroomAssessments';
import prof_area_assessments_attempt from './professor_area/AssessmentsAttempts';
import prof_area_assignments from './professor_area/ClassroomAssignments';
import prof_area_assignments_attempt from './professor_area/AssignmentAttempts';
import prof_area_classroom from './professor_area/Classrooms';
import prof_area_classroom_enrollments from './professor_area/ClassroomEnrollments';
import prof_area_discussion_threads from './professor_area/DiscussionThreads';
import prof_area_forum from './professor_area/Forum';
import prof_area_interactive_classes from './professor_area/InteractiveClasses';
import prof_area_notice_boards from './professor_area/NoticeBoards';
import professor_courses from './ProfessorCourses';
import professors from './Professors';
import reports from './Reports';
import roles from './Roles';
import signaturepartners from './SignaturePartners';
import signatures from './Signatures';
import sso_whitelist_emails from './SsoWhitelistEmails';
import testimonials from './Testimonials';
import user_assignments from './assignments/UserAttempts';
import users from './users/Users';
import {
  IAppResource,
  IResource,
  IResourceAndRoutes
} from 'interfaces/resources';
import { getTenant } from 'services/tenants';

export const RESOURCES: IResourceAndRoutes[] = [
  // Home
  home,

  // Área do professor
  _professor_area,
  prof_area_classroom,
  prof_area_discussion_threads,
  prof_area_interactive_classes,
  prof_area_forum,
  prof_area_notice_boards,
  prof_area_classroom_enrollments,
  prof_area_assignments,
  prof_area_assignments_attempt,
  prof_area_assessments,
  prof_area_assessments_attempt,

  // Alunos e docentes
  _students_teachers,
  users,
  course_enrollment,
  graduate_enrollment,
  professors,
  personifications,

  // Cursos
  _courses,
  _classroom_management,
  courses,
  courses_academic_calendars,
  graduate_courses,
  graduate_courses_academic_calendars,
  graduate_courses_enrollment,
  complementary_activities,
  external_items,
  graduate_modules,
  graduate_disciplines,
  graduate_disciplines_modules,
  classrooms,
  classroom_evaluations,
  classroom_enrollments,
  classroom_professors,
  professor_courses,

  // Recursos de Ensino
  _teaching_resources,
  libraries,
  contents,
  library_tag_groups,
  library_tags,
  library_html_containers,
  interactive_classes,

  // Avaliacoes
  _evaluations,
  assessment_questions,
  assessments,
  assessment_user_attempts,
  assignments,
  user_assignments,
  assessments_attepts,
  assignment_attempts,

  // Comunicacao
  _communication,
  noticeBoards,
  comments,
  discussion_threads,
  FaqCoordinators,
  reports,
  ForumReports,
  forum,

  // Secretaria
  _secretary,
  document_templates,
  document_template_courses,
  documentations,
  documentation_association,
  equivalencies,
  academic_records,
  academic_record_equivalencies,

  // Gestao de certificados
  _certificate_management,
  certificates_free_courses,
  certificates_regulated_courses,
  companies,
  contracts,
  certifying_institutions,
  signaturepartners,
  signatures,
  bulk_certificates,

  // Loja Online
  _ecommerce,
  products,
  offer_campaigns,
  product_bundles,
  product_sets,
  product_categories,
  offer_campaign_assets,
  instructors,
  testimonials,
  ecommerce_tags,
  possessions,

  // Vendas
  _sales,
  coupons,
  manualOrders,
  orders,
  ecommerce_divisions,
  bonuses,
  order_payment_plan,

  // Financeiro
  _financial,
  offer_gateway_rules,
  offer_gateway_range_tables,
  hermes_gateways,
  fiscal_templates,
  ecommerce_profit_centers,
  order_refunds,
  order_not_refunds,
  order_payment_refunds,
  franchise_management,

  // Planos de pagamento
  _payment_deals,
  payment_plans,
  payment_plan_deals_discounts,
  fees,
  payment_method_rules,

  // Configuracoes
  _configurations,
  agents,
  sso_whitelist_emails,
  roles,
  log_deleted_users,
  action_logs,

  bulk_bonuses,
  bulk_users,
  bulk_user_suspends,

  // Relatórios Corporativos
  _corporate_reports,
  enrolled_students,
  course_academic_results,
  discipline_academic_results,
  course_completion,
  course_portfolios
];

export const RESOURCE_PATH_TEMPLATES = RESOURCES.reduce(
  (acc, resourceAndRoutes) => {
    const currentResource = resourceAndRoutes.resource as IResource;

    if (currentResource.pathTemplate) {
      acc[currentResource.name] = currentResource.pathTemplate;
    }

    return acc;
  },
  {} as Record<string, string>
);

export const Routes = [...users.routes, ...instructors.routes];

const tenant = getTenant();

export const getResourcesAndRoutes = (): IResourceAndRoutes => {
  const routes: JSX.Element[] = [];
  const resource = RESOURCES.map(
    (resourceAndRoutes: IResourceAndRoutes): IAppResource | undefined => {
      const resource = resourceAndRoutes.resource as IResource;
      routes.push(...resourceAndRoutes.routes);

      if (
        tenant.disabledFeatures?.includes(resource.name) ||
        tenant.disabledFeatures?.includes(resource.parentName || '') ||
        resource.onlyPermission
      ) {
        return;
      }

      return {
        name: resource.name,
        pathTemplate: resource.pathTemplate,
        list: resource.list,
        show: resource.show,
        edit: resource.edit,
        create: resource.create,
        icon: resource.icon,
        parentName: resource.parentName,
        options: {
          label: resource.label,
          route: `${resource.parentName}/${resource.route || resource.name}`,
          hide: resource.hide
        }
      };
    }
  ).filter(
    (resource: IAppResource | undefined): resource is IAppResource => !!resource
  );

  return {
    resource,
    routes
  };
};
